import React from 'react'

const GPQuestionIcon = (
  <>
    <g clipPath="url(#clip0_3168_19415)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#1890FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12Z"
        fill="#1890FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.45734 4.34652C7.87995 4.29226 7.19888 4.4048 6.60299 4.66835C6.26627 4.81727 5.87257 4.66503 5.72364 4.32831C5.57471 3.99158 5.72696 3.59788 6.06368 3.44895C6.85379 3.0995 7.76272 2.94204 8.58208 3.01903C9.38521 3.0945 10.2321 3.41363 10.6935 4.1602C11.5591 5.561 10.863 7.06588 9.69626 8.05294C9.197 8.47533 8.94989 8.77007 8.82137 9.00058C8.70517 9.20901 8.66667 9.39857 8.66667 9.66665C8.66667 10.0348 8.36819 10.3333 8 10.3333C7.63181 10.3333 7.33334 10.0348 7.33334 9.66665C7.33334 9.23473 7.40268 8.80712 7.6568 8.35131C7.89862 7.91756 8.28434 7.50097 8.83508 7.03503C9.76839 6.24542 9.9196 5.4443 9.55921 4.8611C9.40755 4.61567 9.05097 4.4023 8.45734 4.34652Z"
        fill="#1890FF"
      />
    </g>
    <clipPath id="clip0_3168_19415">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </>
)

export default GPQuestionIcon
